module.exports = __webpack_public_path__ + "img/paypal.d12a4a9a.png";